<template lang="pug">
b-modal#modal-share-heatmap(
  :title="heatmapShared ? 'ヒートマップは外部共有されています。' : 'ヒートマップを外部に共有しますか？'",
  size="lg"
)
  .row
    p.col-12(v-if="!heatmapShared")
      | ヒートマップを外部に共有することができます。
      br/
      | 共有された相手は、以下のWebサイトのヒートマップを
      br/
      | サイトリードにログインせずに閲覧することができます。
      br/
      span.share-note ・共有された相手は、共有されたURLのヒートマップのみ閲覧ができます。
    p.col-12(v-else)
      | 以下のヒートマップは、URLを知っている人が、
      br/
      | サイトリードにログインせずに、閲覧することができます。
      br/
      span.share-note ・共有された相手は、共有されたURLのヒートマップのみ閲覧ができます。
      br/
      span.share-note ・「共有を停止する」を押下すると、共有用URLを介したレポートの閲覧できなくなります。
    .form-group.col-12(v-if="!heatmapShared")
      label WebサイトURL
      input(type="text", class="form-control", :value="heatmapUrl", readonly)
    .form-group.col-12(v-else)
      label ヒートマップ共有用URL
      input(type="text", class="form-control", :value="heatmapShareUrl", readonly)
  template(v-slot:modal-footer)
    .form-group(v-if="!heatmapShared")
      b-button(variant="primary", @click="toggleShare") 共有する
    .form-group(v-else)
      b-button.mr-2(variant="primary", @click="copy") コピーする
      b-button(variant="danger", @click="toggleShare") 共有を停止する
  UpgradeUpperMaster(v-if="show_modal", @close-modal="show_modal = false")
</template>

<script>
import heatmapApi from '../../apis/heatmap';
import UpgradeUpperMaster from "../modals/upgrade_upper_master.vue";

export default {
  props: {
    is_upper_master: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show_modal: false,
    }
  },
  computed: {
    heatmapUrl() {
      return this.$store.state.heatmap.url;
    },
    heatmapShareUrl() {
      return `${window.location.origin}/reports/heatmap/${this.$store.state.heatmap.token}`;
    },
    heatmapShared() {
      return this.$store.state.heatmap.shared;
    },
  },
  methods: {
    show() {
      this.isShared = this.$store.state.heatmap.shared;
      this.$bvModal.show('modal-area-pop-up-copy');
    },
    closeModal() {
      this.$bvModal.hide('modal-area-pop-up-copy');
    },
    async toggleShare() {
      if(!this.is_upper_master){
        this.show_modal = true;
        return
      }
      try {
        const response = await heatmapApi.toggleShared(this.$store.state.heatmap.token);
        this.$store.commit('heatmap/updateHeatmapShared', response.data.shared);
        if(response.data.shared){
          this.$toasted.success("レポートの共有を開始しました");
        } else {
          this.$toasted.success("レポートの共有を停止しました");
        }
      } catch (error) {
        console.error('Error sharing heatmap:', error);
      }
    },
    copy() {
      navigator.clipboard.writeText(this.heatmapShareUrl)
        .then(() => {
          this.$toasted.success("URLをクリップボードにコピーしました");
        })
        .catch(err => {
          console.error('Error copying to clipboard:', err);
        });
    },
  },
  components: {
    UpgradeUpperMaster,
  },
}
</script>
<style lang="scss" scoped>
.share-note {
  display: inline-block;
  white-space: nowrap;
}
</style>
